import logo from '/logo-long.png';
import { Box, Grid, Typography } from '@mui/material';
import { ArrowForwardIos } from '@mui/icons-material';

export function AfterHighRatingSentPage(props: any) {
  const googleReviewURL = 'https://g.page/r/Cfu8AALYL4u1EBM/review';

  return (
    <Box sx={{ p: 2 }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container direction={'column'} spacing={2}>
            <Grid item xs={12} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
              <Grid mt={2} mb={2}>
                <img src={logo} alt="足と歩行のクリニック：リジェ" style={{ margin: '0 auto' }} />
              </Grid>
              <Typography mb={2} pt={2} fontSize={'14px'}>
                ご意見ありがとうございました！
                <br />
                Googleでも評価をしていただけると、
                <br />
                大変励みになります。
              </Typography>
              <a href={googleReviewURL} target="_blank" rel="noopener noreferrer">
                <GoogleSubmitButton label="Googleで評価する" onClick={() => {}} />
              </a>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

interface MenuButtonProps {
  label: string;
  size?: 'text-xs' | 'text-sm' | 'text-base' | 'text-lg' | 'text-xl';
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}
const GoogleSubmitButton = ({ label, onClick }: MenuButtonProps) => {
  return (
    <button
      onClick={onClick}
      style={{
        width: '300px',
        height: '48px',
        color: '#FFFFFF',
        textAlign: 'left',
        margin: 'auto',
        marginTop: '32px'
      }}
      className="bg-primary flex relative rounded"
    >
      <div className="text-base m-auto font-bold" style={{ whiteSpace: 'pre-wrap' }}>
        {label}
      </div>
      <div>
        <ArrowForwardIos style={{ position: 'absolute', top: '16px', right: '11px', fontSize: '16px' }} />
      </div>
    </button>
  );
};
